// What the TipTap StarterKit editor (`RichTextField`) can hold. Any other tag or attribute is dropped on its
// first edit, so a value carrying one is edited as HTML source instead.
const KEPT_TAGS = new Set([
  'p',
  'br',
  'strong',
  'b',
  'em',
  'i',
  'u',
  's',
  'strike',
  'del',
  'ul',
  'ol',
  'li',
  'a',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'blockquote',
  'code',
  'pre',
  'hr',
]);

const KEPT_ATTRIBUTES: Record<string, Set<string>> = {
  a: new Set(['href', 'target', 'rel']),
  ol: new Set(['start']),
};

const TAG = /<\s*([a-zA-Z][\w-]*)([^>]*)>/g;
const ATTRIBUTE = /([^\s=/]+)\s*(?:=\s*(?:"[^"]*"|'[^']*'|[^\s>]+))?/g;

/** True when the rich text editor can load and re-save this HTML without losing markup. */
export function richTextKeeps(html: string): boolean {
  if (/<!--/.test(html)) return false;
  for (const [, rawTag, rawAttributes] of html.matchAll(TAG)) {
    const tag = rawTag.toLowerCase();
    if (!KEPT_TAGS.has(tag)) return false;
    const allowed = KEPT_ATTRIBUTES[tag];
    for (const [, name] of rawAttributes.replace(/\/\s*$/, '').matchAll(ATTRIBUTE)) {
      if (!allowed?.has(name.toLowerCase())) return false;
    }
  }
  return true;
}
